import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/T.png';

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 antialiased">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-md">
            <img src={logo} alt="Truyon Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold tracking-tight text-gray-900">truyon</span>
          </Link>
          <Link 
            to="/" 
            className="text-indigo-600 hover:text-indigo-700 font-medium text-sm flex items-center gap-1 transition-colors focus:outline-none focus:underline"
          >
            &larr; Back to Home
          </Link>
        </div>
      </header>

      {/* Main Container */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          
          {/* Hero Section */}
          <section className="bg-slate-900 px-6 sm:px-12 py-12 sm:py-16 text-center text-white relative">
            <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-indigo-500/20 text-indigo-300 border border-indigo-500/30 mb-4 tracking-wide uppercase">
              Get in Touch
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Contact Us
            </h1>
            <p className="text-slate-300 mt-4 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
              Have questions about Truyon ERP, institutional onboarding, or technical inquiries? Reach out to our team directly.
            </p>
          </section>

          {/* Contact Details Grid */}
          <section className="px-6 sm:px-12 py-10 border-b border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              {/* Email Communications */}
              <div className="p-6 bg-slate-50 rounded-xl border border-slate-200/80">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center mb-4">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-1">Electronic Mail</h2>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Email Inquiries</h3>
                <p className="text-xs text-gray-500 mb-4">Direct your query to the appropriate team for faster response times:</p>
                
                <div className="space-y-4 text-sm">
                  <div className="p-3 bg-white rounded-lg border border-gray-100 shadow-xs">
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider block mb-1">Technical Support</span>
                    <a href="mailto:support@truyon.com" className="font-semibold text-indigo-600 hover:text-indigo-700 transition-colors">
                      support@truyon.com
                    </a>
                  </div>
                  <div className="p-3 bg-white rounded-lg border border-gray-100 shadow-xs">
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider block mb-1">Sales & Institutional Partnerships</span>
                    <a href="mailto:sales@truyon.com" className="font-semibold text-indigo-600 hover:text-indigo-700 transition-colors">
                      sales@truyon.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Phone & Business Hours */}
              <div className="p-6 bg-slate-50 rounded-xl border border-slate-200/80">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center mb-4">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-1">Direct Assistance</h2>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Phone & Operating Hours</h3>
                <p className="text-xs text-gray-500 mb-4">Available during standard business operational hours:</p>
                
                <div className="space-y-4 text-sm">
                  <div className="p-3 bg-white rounded-lg border border-gray-100 shadow-xs">
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider block mb-1">Primary Contact Line</span>
                    <a href="tel:+918088829438" className="font-semibold text-gray-900 hover:text-indigo-600 transition-colors">
                      +91 80888-29438
                    </a>
                  </div>
                  <div className="p-3 bg-white rounded-lg border border-gray-100 shadow-xs">
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider block mb-1">Working Schedule</span>
                    <span className="font-semibold text-gray-700">
                      Monday – Friday, 9:00 AM – 6:00 PM IST
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </section>

          {/* Registered Office & Statutory Info */}
          <section className="px-6 sm:px-12 py-10 bg-slate-50 border-b border-gray-100">
            <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Corporate Office</h2>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Registered Address</h3>

            <div className="bg-white p-6 rounded-xl border border-gray-200 text-sm text-gray-600 space-y-4 shadow-xs">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 pb-3 border-b border-gray-100">
                <span className="font-semibold text-gray-900">Legal Entity Name</span>
                <span className="sm:col-span-2 text-gray-800">TRUYON TECHNOLOGIES (OPC) PVT LTD</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 pb-3 border-b border-gray-100">
                <span className="font-semibold text-gray-900">Corporate Identification Number (CIN)</span>
                <span className="sm:col-span-2 font-mono text-gray-800 bg-gray-100 px-2.5 py-1 rounded w-fit text-xs font-medium">
                  U62013KA2026OPC221006
                </span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <span className="font-semibold text-gray-900">Registered Office</span>
                <span className="sm:col-span-2 text-gray-700 leading-relaxed">
                  Unit 101, Oxford Towers, 139/88, HAL Old Airport Rd, H.A.L II Stage, Bangalore North, Bangalore, Karnataka, India, 560008.
                </span>
              </div>
            </div>
          </section>

          {/* Footer */}
          <footer className="px-6 sm:px-12 py-6 bg-white">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-gray-500">
              <span>© {new Date().getFullYear()} TRUYON TECHNOLOGIES (OPC) PVT LTD. All rights reserved.</span>
              <div className="flex flex-wrap gap-5 font-medium">
                <Link to="/about-us" className="hover:text-indigo-600 transition-colors">About Us</Link>
                <Link to="/terms-of-service" className="hover:text-indigo-600 transition-colors">Terms</Link>
                <Link to="/privacy-policy" className="hover:text-indigo-600 transition-colors">Privacy</Link>
                <Link to="/refund-policy" className="hover:text-indigo-600 transition-colors">Refund</Link>
              </div>
            </div>
          </footer>

        </div>
      </main>
    </div>
  );
};

export default ContactUs;